import cloneDeep from "lodash/cloneDeep";

import getProperty from "../helpers/getProperty.js";

import transform from "../transform/transform";

import Models from "../models/models";

import { getEssentialJobData } from "@/helpers/utility/jobDataSelector.js";

const models = new Models();
const stateModel = models.state();

const { transformUserData, transformJobData } = transform();

export default {
  setJobDistancesData(state, data) {
    let needToPush = true;

    state.jobDistances.forEach(function (el, index) {
      if (el.id == data.id) {
        state.jobDistances[index] = data;
        // console.log('skip mutation ' + index);
        needToPush = false;
      }
    });

    if (needToPush) {
      if (state.jobDistances.length >= 100) {
        // cache size
        state.jobDistances.pop();
      }
      state.jobDistances.push(data);
    }
  },

  setLoggedStatus(state, data) {
    state.loggedIn = data;
  },

  setPageBack(state, data) {
    let stateValue = getProperty(state.pages, data.state);
    stateValue.backPages.push(data.page);
  },
  setLastPage(state, data) {
    state.pages.backPage = data;
  },

  setAuthPageIntro(state, data) {
    state.pages.auth.intro = data;
  },
  addAuthPageBack(state, data) {
    state.pages.auth.back.push(data);
  },
  setAuthPageBack(state, data) {
    state.pages.auth.back = [data];
  },

  setJobCreatePageData(state, data) {
    Object.keys(data).forEach((key) => {
      console.log("🚀 ~ setJobCreatePageData ~ key:", key)
      let value = data[key];
      switch (key) {
        case "shifts":
          state.pages.job.create.shifts = value;
          break;
        case "isBlockShift":
          state.pages.job.create.isBlockShift = value.value == true ? 1 : 0;
          break;

        case "dates":
          state.pages.job.create.dates = value[value.length - 1];
          break;

        case "schedule":
          state.pages.job.create.schedule = value;
          break;
        case "rate":
          state.pages.job.create.minRate = value.minRate;
          state.pages.job.create.maxRate = value.maxRate;

          break;
        case "weekendRate":
          state.pages.job.create.weekendMinRate = value.weekendMinRate;
          state.pages.job.create.weekendMaxRate = value.weekendMaxRate;
          break;
        case "weekendSaturdayRate":
          state.pages.job.create.saturdayMinRate = value.saturdayMinRate;
          state.pages.job.create.saturdayMaxRate = value.saturdayMaxRate;
          break;
        case "weekendSundayRate":
          state.pages.job.create.sundayMinRate = value.sundayMinRate;
          state.pages.job.create.sundayMaxRate = value.sundayMaxRate;
          break;
        case "platform_role_id":
          state.pages.job.create.platform_role_id = value;
          break;
        case "covid_cert_required":
          state.pages.job.create.covid_cert_required = value;
          break;
        case "language_conditions":
          state.pages.job.create.language_conditions = value;
          break;
        case "languages":
          state.pages.job.create.languages =
            !state.pages.job.create.language_conditions || value[0] == null
              ? ""
              : value;
          break;
        case "paying_for_travel":
          state.pages.job.create.paying_for_travel = Number(value);
          break;
        case "max_travel_amount":
          console.log("mutatiion of max payment", value);
          state.pages.job.create.max_travel_amount = value;
          break;
        case "enable_travel_allowance_for_first_and_last_day":
          state.pages.job.create.enable_travel_allowance_for_first_and_last_day = Number(value);
          break;
        case "pay_for_flights":
          state.pages.job.create.pay_for_flights = Number(value);
          break;
        case "pay_for_accommodation":
          state.pages.job.create.pay_for_accommodation = Number(value);
          break;
        case "solo":
          state.pages.job.create.solo = Number(value);
          break;
        case "open_up":
          state.pages.job.create.open_up = Number(value);
          break;
        case "close":
          state.pages.job.create.close = Number(value);
          break;
        case "admin_aids":
          state.pages.job.create.admin_aids = Number(value);
          break;
        case "home_med_review":
          state.pages.job.create.home_med_review = Number(value);
          break;
        case "number_of_technicians":
          state.pages.job.create.number_of_technicians = value;
          break;
        case "num_of_tech":
          state.pages.job.create.num_of_tech =
            !state.pages.job.create.number_of_technicians || value == null
              ? ""
              : value;
          break;
        case "additional_notes":
          state.pages.job.create.additional_notes = value;
          break;
        case "notes":
          state.pages.job.create.notes =
            !state.pages.job.create.additional_notes || value == null
              ? ""
              : value;
          break;
        case "parking_check":
          state.pages.job.create.parking_check = value;
          break;
        case "parking":
          state.pages.job.create.parking =
            !state.pages.job.create.parking_check || value == null ? "" : value;
          break;
        case "visibility_status":
          state.pages.job.create.visibility_status = value;
          break;
        case "more_option_internal_pools":
          state.pages.job.create.more_option_internal_pools = value;
          break;
        case "more_option_prefered_locum":
          state.pages.job.create.more_option_prefered_locum = value;
          break;
        case "more_option_open_marketplace":
          state.pages.job.create.more_option_open_marketplace = value;
          break;
        case "more_option_agency":
          state.pages.job.create.more_option_agency = value;
          break;
        case "job_lock_hour":
          state.pages.job.create.job_lock_hour = value;
          break;
        case "shift_application_type":
          state.pages.job.create.shift_application_type = value;
          break;
        case "application_radius":
          state.pages.job.create.application_radius = value;
          break;
      }
    });
  },

  setJobListingCreatePageData(state, data) {
    Object.keys(data).forEach((key) => {
      let value = data[key];
      switch (key) {
        case "job_type":
          state.pages.jobListing.create.job_type = value;
          break;
        case "job_title":
          state.pages.jobListing.create.job_title = value;
          break;
        case "job_location":
          state.pages.jobListing.create.job_location = value;
          break;
        case "job_category":
          state.pages.jobListing.create.job_category = value;
          break;
        case "job_skills":
          state.pages.jobListing.create.job_skills = value;
          break;
        case "min_rate":
          state.pages.jobListing.create.min_rate = value;
          break;
        case "max_rate":
          state.pages.jobListing.create.max_rate = value;
          break;
        case "rate_type":
          state.pages.jobListing.create.rate_type = value;
          break;
        case "bonus":
          state.pages.jobListing.create.bonus = value;
          break;
        case "job_description":
          state.pages.jobListing.create.job_description = value;
          break;
        case "questionary":
          state.pages.jobListing.create.questionary = value;
          break;
        case "questions":
          state.pages.jobListing.create.questions = value;
          break;
        case "short_description":
          state.pages.jobListing.create.short_description = value;
          break;
        case "job_post_payment_id":
          state.pages.jobListing.create.job_post_payment_id = value;
          break;
        case "payment_intent_id":
          state.pages.jobListing.create.payment_intent_id = value;
          break;
        case "stripe_customer_id":
          state.pages.jobListing.create.stripe_customer_id = value;
          break;
        case "platform_role_id":
          state.pages.jobListing.create.platform_role_id = value;
          break;
        case "federal_pharmacist_support":
          state.pages.jobListing.create.federal_pharmacist_support = value;
          break;
        case "hide_salary":
          state.pages.jobListing.create.hide_salary = value;
          break;
      }
    });
  },

  setGuestShiftRecordCreatePageData(state, data) {
    Object.keys(data).forEach((key) => {
      let value = data[key];
      switch (key) {
        case "shifts":
          state.pages.guestShift.create.shifts = value;
          break;

        case "dates":
          state.pages.guestShift.create.dates = value[value.length - 1];
          break;

        case "schedule":
          state.pages.guestShift.create.schedule = value;
          break;
        case "payRate":
          state.pages.guestShift.create.payRate = value;
          break;
        case "shiftNotes":
          state.pages.guestShift.create.shiftNotes = value;
          break;
        case "firstName":
          state.pages.guestShift.create.firstName = value;
          break;
        case "lastName":
          state.pages.guestShift.create.lastName = value;
          break;
        case "email":
          state.pages.guestShift.create.email = value;
          break;
        case "mobileNumber":
          state.pages.guestShift.create.mobileNumber = value;
          break;
        case "additionalTermCondition":
          state.pages.guestShift.create.additionalTermCondition = value;
          break;
        case "requestAphraIns":
          state.pages.guestShift.create.requestAphraIns = Number(value);
          break;
        case "files":
          var testfile = [];
          var filelength = value.length;
          for (var i = 0; i < filelength; i++) {
            testfile[i] = value[i].buffer;
          }
          state.pages.guestShift.create.files = value;
          break;
      }
    });
  },
  clearJobCreatePageData(state) {
    state.pages.job.create = cloneDeep(stateModel.pages.job.create);
  },
  clearJobListingCreatePageData(state) {
    state.pages.jobListing.create = cloneDeep(
      stateModel.pages.jobListing.create
    );
  },
  clearGuesstShiftRecordCreatePageData(state) {
    state.pages.guestShift.create = cloneDeep(
      stateModel.pages.guestShift.create
    );
  },
  setJobShiftsBookPageData(state, data) {
    state.pages.job.shifts.book = data;
  },
  clearJobShiftsBookPageData(state) {
    state.pages.job.shifts.book = cloneDeep(stateModel.pages.job.shifts.book);
  },
  setGuestShiftDetails(state, data) {
    Object.keys(data).forEach((key) => {
      state.pages.guestShift.details[key] = data[key];
    });
  },

  setGuestShiftPublic(state, data) {
    Object.keys(data).forEach((key) => {
      state.guestShiftPublic[key] = data[key];
    });
  },

setJobDetails(state, data) {
    // Optimize the data before storing
    const optimizedData = getEssentialJobData(data);
    
    Object.keys(optimizedData).forEach((key) => {
      state.pages.job.details[key] = optimizedData[key];
    });
  },
  clearJobDetails(state) {
    state.pages.job.details = cloneDeep(stateModel.pages.job.details);
  },

  setJobFiltersData(state, data) {
    Object.keys(data).forEach((key) => {
      state.pages.job.filters[key] = data[key];
    });
  },
  clearJobFiltersData(state) {
    state.pages.job.filters = cloneDeep(stateModel.pages.job.filters);
  },

  setReportData(state, data) {
    Object.keys(data).forEach((key) => {
      state.pages.report[key] = data[key];
    });
  },
  clearReportData(state) {
    state.pages.report = cloneDeep(stateModel.pages.report);
  },

  setVerifyPageData(state, data) {
    Object.keys(data).forEach((key) => {
      state.pages.verify[key] = data[key];
    });
  },
  clearVerifyPageData(state, data) {
    Object.keys(data).forEach((key) => {
      state.pages.verify[key] = null;
    });
  },

  setLanguagesList(state, data) {
    state.languages.list = data;
  },
  setStripeConnectLink(state, data) {
    state.stripeConnectLink = data;
  },
  setStripeConnectStatus(state, data) {
    state.stripeConnectStatus = data;
  },
  setStripeRefreshLink(state, data) {
    state.stripeRefreshLink = data;
  },
  setPaymentIntent(state, data) {
    state.paymentIntent = data;
  },
  setJobPreviewDetails(state, data) {
    state.jobPreview = data;
  },
  setPaymentIntentDescription(state, data) {
    state.paymentIntentDescription = data;
  },
  setPaymentIntentCheck(state, data) {
    state.paymentIntentCheck = data;
  },
  setStripeLoginLink(state, data) {
    state.stripeLoginLink = data;
  },

  AUTH_SUCCESS: (state, token) => {
    state.status = "success";
    state.token = token;
  },
  AUTH_LOGOUT: (state) => {
    stateModel.user.email = state.user.email;

    Object.keys(state).forEach((key) => {
      state[key] = cloneDeep(stateModel[key]);
    });

    // router.push({
    //     name: "auth",
    // });

    // router.go(0); // Remove search component

    location.href = "/auth";
  },
  CLEAR_USER_DATA: (state) => {
    state.user = cloneDeep(stateModel.user);
    // router.go(0);
  },
  SET_USER_DATA(state, data) {
    console.log("set user data", data);
    transformUserData(data, state, {
      stateName: "user",
    });
  },
  SET_USER_ROLE(state, data) {
    state.user.role = data;
  },
  SET_USER_PLATFORM_ROLE(state, data) {
    state.user.platformRole = data;
  },
  SET_USER_WORK_TYPE(state, data) {
    state.user.workType = data;
  },
  SET_USER_EMAIL(state, data) {
    state.user.email = data;
  },
  SET_USER_PHONE(state, data) {
    state.user.mobileNumber = data;
  },

  SET_USER_ENVIRONMENT_VALUE(state, data) {
    state.user.environmentValue.services = data.services;
    state.user.environmentValue.software = data.software;
    state.user.environmentValue.scriptsPerDay = data.scripts;
    state.user.environmentValue.average_scripts_saturday_id =
      data.average_scripts_saturday_id;
    state.user.environmentValue.average_scripts_sunday_id =
      data.average_scripts_sunday_id;
    state.user.environmentValue.number_of_patients = data.number_of_patients;
  },

  SET_ENVIRONMENT_SETTING_VALUE(state, data) {
    state.setting.environmentValue.software = data.software;
    state.setting.environmentValue.scriptsPerDay = data.scripts;
  },

  SET_PHARMACY_SERVICES(state, data) {
    state.common.pharmacy.services = data;
  },
  SET_PHARMACY_SOFTWARE(state, data) {
    state.common.pharmacy.software = data;
  },
  SET_PHARMACY_SCRIPTS_COUNT(state, data) {
    state.common.pharmacy.scriptsPerDay = data;
  },

  SET_PHARMACY_SCRIPTS_COUNT_SATURDAY(state, data) {
    state.common.pharmacy.average_scripts_saturday_id = data;
  },
  SET_PHARMACY_SCRIPTS_COUNT_SUNDAY(state, data) {
    state.common.pharmacy.average_scripts_sunday_id = data;
  },
  SET_PHARMACY_PATIENTS_QUANTITY(state, data) {
    state.common.pharmacy.number_of_patients = data;
  },
  SET_STATES(state, data) {
    state.common.states = data;
  },
  SET_JOB_LIST(state, data) {
    data.forEach((element) => {
      transformJobData(state, element);
    });
    state.jobs = data;
  },
  setBillingSession(state, data) {
    state.billingSession = data;
  },
  setCurrentJobNewData(state, data) {
    state.refreshJobData = data;
  },

  setShiftApplictionDetails(state, data) {
    Object.keys(data).forEach((key) => {
      state.shiftApplicationDetails[key] = data[key];
    });
  },
  setRedirectRoute(state, route) {
    state.redirectRoute = route;
  },
  clearRedirectRoute(state) {
    state.redirectRoute = null;
  },
  setLocumBlockedPharmacies(state, data) {
    state.locumBlockedPharmacies = data;
  },
  setPharmacyTypes(state, data) {
    state.pharmacyTypes = data;
  },
  setAppliedCoupon(state, data) {
    state.appliedCoupon = data;
  },
  setPharmacyAdditionalInfo(state, data) {
    state.pharmacyAdditionalInfo = data;
  },
};
